import _extends from "@babel/runtime/helpers/extends";
import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import './Style.scss';

var ColorLabelContainer = /*#__PURE__*/function (_Component) {
  _inherits(ColorLabelContainer, _Component);

  var _super = _createSuper(ColorLabelContainer);

  function ColorLabelContainer(props) {
    var _this;

    _classCallCheck(this, ColorLabelContainer);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setContainer", function (element) {
      _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "onResize", function () {
      if (_this.container == null) {
        return false;
      }

      var containerWidth = _this.container.clientWidth;

      if (_this.contentWidth == null) {
        return false;
      }

      if (containerWidth < _this.contentWidth) {
        if (_this.state.collapse == false) {
          _this.setState({
            collapse: true
          });
        }
      } else {
        if (_this.state.collapse == true) {
          _this.setState({
            collapse: false
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculateCollapse", function () {
      // Issue where the container is no longer rendered on screen but the calculateCollapse still runs
      // and refs['container'] == undefined
      if (_this.container != null) {
        var contentWidth = 0;

        var dots = _toConsumableArray(_this.container.querySelectorAll('.dot'));

        dots.forEach(function (dot) {
          if (dots.length > 1) {
            // Add extra 10 px for margin
            contentWidth = contentWidth + dot.clientWidth + 25;
          } else {
            contentWidth = contentWidth + dot.clientWidth;
          }
        });
        _this.contentWidth = contentWidth;
      }
    });

    _this.state = {
      collapse: false
    };
    _this.container = null;
    _this.contentWidth = null;
    return _this;
  }

  _createClass(ColorLabelContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateCollapse();
      this.onResize();
      window.addEventListener('resize', this.onResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevChildren = [];
      var currentChildren = [];

      if (prevProps != null && prevProps.children != null && _typeof(prevProps.children) == 'object') {
        prevChildren = prevProps.children;
      }

      if (this.props != null && this.props.children != null && _typeof(this.props.children) == 'object') {
        currentChildren = prevProps.children;
      }

      if (prevChildren.length != currentChildren.length) {
        this.calculateCollapse();
        this.onResize();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var collapse = this.state.collapse;
      var props = Object.assign({}, this.props);
      delete props.collapse;
      delete props.inline;
      delete props.test;
      return /*#__PURE__*/React.createElement("div", _extends({
        ref: this.setContainer,
        className: 'dots-container' + (this.props.collapse || collapse ? ' collapse' : '') + (!this.props.collapse && !collapse ? ' show-content' : '') + (this.props.inline ? ' inline' : '')
      }, props), children, !this.props.inline ? /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }) : null);
    }
  }]);

  return ColorLabelContainer;
}(Component);

export default ColorLabelContainer;